import * as firebase from "firebase";
import { createBrowserHistory } from "history";
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Loadable from "react-loadable";
import { Route, Router } from "react-router-dom";
import { Env } from "../../../lib/env";
import "../../../lib/iframe_autofit_send";
import { Runtime } from "../../runtime";
import { setupResizer } from "./resizer";
import * as R from "./routes";

const pages = {
  banner: Loadable({
    loader: () => import(/* webpackChunkName: "election-embed-banner" */ "./pages/banner"),
    loading: () => <div />
  }),
  nrSharesSwitzerland: Loadable({
    loader: () =>
      import(/* webpackChunkName: "election-embed-nr-shares-ch" */ "./pages/nr-shares-ch"),
    loading: () => <div />
  }),
  nrSharesCanton: Loadable({
    loader: () =>
      import(/* webpackChunkName: "election-embed-nr-shares-canton" */ "./pages/nr-shares-canton"),
    loading: () => <div />
  }),
  nrSeatsSwitzerland: Loadable({
    loader: () =>
      import(/* webpackChunkName: "election-embed-nr-seats-ch" */ "./pages/nr-seats-ch"),
    loading: () => <div />
  }),
  nrSeatsCanton: Loadable({
    loader: () =>
      import(/* webpackChunkName: "election-embed-nr-seats-canton" */ "./pages/nr-seats-canton"),
    loading: () => <div />
  }),
  srCanton: Loadable({
    loader: () => import(/* webpackChunkName: "election-embed-sr-canton" */ "./pages/sr-canton"),
    loading: () => <div />
  }),
  srCountry: Loadable({
    loader: () => import(/* webpackChunkName: "election-embed-sr-country" */ "./pages/sr-country"),
    loading: () => <div />
  })
};

// ----------------------------------------------------------------------------
// Here is where the main execution starts.

setupResizer();

const main = async () => {
  // In the embed page we don't enable Firestore persistence (see standalone index.tsx file).
  // It adds overhead during initialization, and only has benefit when the user navigates
  // between pages inside a single application. That's not the case in the embed app.
  const db = firebase.firestore();

  const containerElement = document.getElementById("app");
  const history = createBrowserHistory({ basename: "/embed" });

  ReactDOM.render(
    <Runtime history={history} appVariant="election">
      <Env.Provider value={{ history, db }}>
        <Router history={history}>
          <Route path={R.banner(":year")} exact component={pages.banner} />
          <Route
            path={R.nrSharesSwitzerland(":year")}
            exact
            component={pages.nrSharesSwitzerland}
          />
          <Route
            path={R.nrSharesCanton(":year", ":cantonId")}
            exact
            component={pages.nrSharesCanton}
          />
          <Route path={R.nrSeatsSwitzerland(":year")} exact component={pages.nrSeatsSwitzerland} />
          <Route
            path={R.nrSeatsCanton(":year", ":cantonId")}
            exact
            component={pages.nrSeatsCanton}
          />
          <Route path={R.srCountry(":year")} exact component={pages.srCountry} />
          <Route path={R.srCanton(":year", ":cantonId")} exact component={pages.srCanton} />
        </Router>
      </Env.Provider>
    </Runtime>,
    containerElement
  );
};

main().catch(err => {
  console.error("main", err);
});
